// ═══════════════════════════════════════════════════════════════
// Composable assistant d'aide IA (feature 'assistant')
// ═══════════════════════════════════════════════════════════════
// Gère un fil de discussion local (question → réponse) avec l'API
// /api/assistant/ask. Aucun accès aux données du compte : aide « comment
// faire » uniquement. Pas de persistance — le fil vit le temps de la session.
// ═══════════════════════════════════════════════════════════════

import { ref } from 'vue';
import { api, errorCode } from '@/lib/api';

export function useAssistant() {
  const messages = ref([]); // { role: 'user' | 'assistant', text }
  const loading = ref(false);
  const error = ref(null); // code d'erreur API (ERR_*) ou null

  async function ask(question, { route, locale } = {}) {
    const q = (question || '').trim();
    if (!q || loading.value) return;

    error.value = null;
    messages.value.push({ role: 'user', text: q });
    loading.value = true;
    try {
      const { data } = await api.post('/assistant/ask', {
        question: q,
        route: route || undefined,
        locale: locale === 'en' ? 'en' : 'fr',
      });
      messages.value.push({ role: 'assistant', text: data.answer || '' });
    } catch (e) {
      error.value = errorCode(e);
    } finally {
      loading.value = false;
    }
  }

  function reset() {
    messages.value = [];
    error.value = null;
  }

  return { messages, loading, error, ask, reset };
}
